<template>
  <div class="judiciaryBox">
    <div class="judiciaryMain">
      <breadcrumb>
        <el-breadcrumb slot="breadcrumb" separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>我的公证</el-breadcrumb-item>
        </el-breadcrumb>
      </breadcrumb>
       <!-- <Analysis :btnTop="'24px'" :btnLeft="'107px'" :textTop="'43px'" :textLeft="'107px'">
        <p>此模块展示与您相关的公证任务清单。</p> 
        <p>&nbsp;&nbsp;【赋强公证】：在签订了赋强贷款合同后，由借款人申请，贷款人全程可见的一种公证业务。办理了赋强公证后，金融机构在后续可根据业务实际需要申请强执公证。</p>
        <p>&nbsp;&nbsp;【强执公证】：在已理了赋强公证的贷款合同多次违约时可由金融机构申请，公证处核准的一种公证业务。办理了强执公证后，金融机构可凭此及其它证据材料向地方法院申请执行。</p>
      </Analysis> -->
      <div class="signatureCon">
        <el-tabs type="card" v-model="activeName" @tab-click="handleClick">
          <!-- <el-tab-pane label="合同公证" name="first" >
            <notar></notar>
          </el-tab-pane> -->
          <!-- <el-tab-pane label="司法鉴定" name="second">
            <exper></exper>
          </el-tab-pane> -->
          <el-tab-pane label="赋强公证" name="third">
            <lawyer></lawyer>
          </el-tab-pane>
          <el-tab-pane label="强执公证" name="execution">
            <execution></execution>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    </div>
</template>
<script>
import notar from "./components/notariza.vue";
import exper from "./components/judicialExpertise.vue";
import lawyer from "./components/lawyer.vue";
import execution from "./components/execution.vue";
import Dialog from "@common/Dialog.vue";
import Analysis from "@common/Analysis.vue";
import apply from "./components/applyNotar.vue";
import solicitor from "./components/solicitorServices.vue";
import breadcrumb from "@common/Breadcrumb.vue";

export default {
  data() {
    return {
      activeName: "third",
      num: "",
      ruleFormjdc: {
        comName: ""
      },
      rulesjdc: {
        comName: [
          { required: true, message: "输入要鉴定合同名称", trigger: "blur" }
        ]
      }
    };
  },

  mounted() {
    if (this.$route.query.flag == "first") {
      this.activeName = "first";
    }
    // if (this.$route.query.flag == "second") {
    //   this.activeName = "second";
    // }
    if (this.$route.query.flag == "third") {
      this.activeName = "third";
    }
    if (this.$route.query.flag == "execution") {
      this.activeName = "execution";
    }
  },
  methods: {
    handleClick(tab, event) {
    },
  },
  components: {
    notar,
    exper,
    lawyer,
    Dialog,
    solicitor,
    apply,
    breadcrumb,
    execution,
    Analysis
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.judiciaryBox {
  width:100%;
  height: 100%;
  overflow-y: scroll;
  .judiciaryMain {
    width: 100%;
    height: 100%;
    background: #fff;
    border-radius: 3px;
    padding: 15px;
    position:relative;
    box-sizing: border-box;
    .signatureCon {
      width: 100%;
      display: table;
      box-sizing: border-box;
      margin-top:30px;
       .el-table td.el-table__cell, .el-table th.el-table__cell.is-leaf,.el-table{
        border-color: #DDDDDD; 
        }
        .el-table--border::after, .el-table--group::after, .el-table::before,.el-table--border::after, .el-table--group::after, .el-table::before{
          background-color: #DDDDDD;
        }
        .el-table th.el-table__cell{
          background: #F1F1F1 !important;
        }
        .el-table__empty-block{
          width: 100% !important;
        }
      .el-tabs--card > .el-tabs__header {
        border: none;
        margin:0;
      }
      .el-tabs--card > .el-tabs__content{
        width:100%;
        padding:15px;
        box-sizing: border-box;
        border: 1px solid #ebeef5;
        margin-top:-1px;
      }
      .el-table .el-table__cell{
        text-align: center;
        padding: 9px 0px;
      }
      .lawyerBox table .cell{
        line-height: 23px;
      }
      .el-tabs--card > .el-tabs__header .el-tabs__nav {
        border: none;
      }
      .el-tabs--border-card {
        box-shadow: none;
        position: relative;
        .add {
          position: absolute;
          right: 20px;
          top: 0;
          padding: 0 20px;
          height: 30px;
          line-height: 30px;
          text-align: center;
          border: 1px solid #db4437;
          font-size: 12px;
          color: #db4437;
          img {
            vertical-align: middle;
            width: 11px;
            height: 11px;
            margin-right: 5px;
          }
        }
        .el-tabs__header {
          background-color: #f5f5f5;
          width: 355px;
        }
      }
      .el-tabs__nav-scroll {
        height: 36px;
        line-height: 30px;
        .el-tabs__item {
          width: 212px;
          line-height: 36px;
          height: 36px;
          text-align: center;
          border: 1px solid #e4e7ed;
          border-bottom:0;
          background-color: #f5f5f5;
        }
        .el-tabs__item:nth-child(2) {
          // border-right: none;
          border-left: none;
        }
      }
      .el-tabs__item:hover{
         color: #db4437;
      }
      .el-tabs__item.is-active {
        color: #db4437;
        border-top:2px solid #db4437;
        border-bottom: none;
        position: relative;
        background-color: #fff;
      }
    }
  }
  .successFulBox {
    height: 200px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    color: #646464;
  }
  .authenticateBox {
    height: 319px;
    width: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
    .doingNum,
    .hint {
      width: 100%;
      text-align: center;
      height: 32px;
      line-height: 32px;
      background-color: #f0f0f0;
      font-size: 12px;
      color: #969696;
    }
    .hint {
      width: 473px;
      margin-top: 20px;
    }
    .el-form {
      .el-form-item {
        margin-bottom: 0;
        .el-form-item__label {
          font-size: 12px;
          color: #919191;
          line-height: 30px;
          padding: 0;
        }
        .el-form-item__content {
          line-height: 30px;
          .el-input {
            .el-input__inner {
              width: 170px;
              height: 30px;
              line-height: 30px;
              border-radius: 0;
              color: red;
            }
          }
          .el-button {
            width: 100px;
            height: 32px;
            line-height: 32px;
            padding: 0;
            font-size: 12px;
            background-color: #fff;
            color: #646464;
            border: 1px solid #c8c8c8;
            border-radius: 0;
          }
          .el-button--primary {
            color: #db4437;
            border-color: #db4437;
            float: left;
          }
          .el-button:nth-child(2) {
            float: right;
          }
        }
      }
      .el-form-item:nth-child(1) {
        margin-top: 27px;
        margin-bottom: 11px;
      }
      .primaryBox {
        margin-top: 20px;
        .el-form-item__content {
          margin-left: 0 !important;
        }
      }
    }
  }
  .applyNotar {
    width: 100%;
    height: 319px;
  }
}
</style>
